function ResearchDevelopment(props) {

    const recruitContentsId = 'recruit-job-16';

    return (
        <div className="recruit_contents" id={recruitContentsId}>
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">미디어엔지니어</h4>
                <h5 className="recruit_titleline_title">R&amp;D</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <em className="recruit_bold_text">Vision / NLP(Natural Language Processing) 연구 개발</em>
                <ul className="recruit_subinfo_list">
                    <li className="recruit_subinfo_list_inner">머신러닝(Machine Learning) / 딥러닝(Deep Learning) 분야에 대한 전반적인 이해 </li>
                    <li className="recruit_subinfo_list_inner">PyTorch 혹은 Tensorflow 등의 딥러닝 프레임워크에 대한 이해 및 경험</li>
                    <li className="recruit_subinfo_list_inner">머신러닝을 활용한 서비스 개발 경험</li>
                    <li className="recruit_subinfo_list_inner">컴퓨터 과학, 컴퓨터 엔지니어링, 수학 및 관련 분야 전공</li>
                </ul>
                <em className="recruit_bold_text">서비스 플랫폼 개발</em>
                <ul className="recruit_subinfo_list">
                    <li className="recruit_subinfo_list_inner">웹서비스 플랫폼 개발에 대한 이해 및 경험 </li>
                    <li className="recruit_subinfo_list_inner">프레임워크 기반 웹서비스 개발 경험 </li>
                    <li className="recruit_subinfo_list_inner">Back-end 시스템 구현 경험</li>
                    <li className="recruit_subinfo_list_inner">Restful API 설계/구현 경험</li>
                </ul>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <em className="recruit_bold_text">업무</em>
                <p className="recruit_subinfo_text">
                    기술연구소는 미디어 기술 연구 및 S/W 개발을 담당하는 부서입니다.<br />
                    방송 영상 송출 자동화, 차세대 방송 기술 연구 및 표준화, 선거방송 관련 연구 개발 업무부터 AI 기술을 활용한 영상 편집 S/W 개발,<br />
                    음성인식과 기계번역을 활용한 다국어 자막 제작, 스트리밍 기술 기반 가상채널 서비스, 콘텐츠 유통 데이터 분석 등에 이르기까지<br />
                    S/W 및 AI 기술을 기반으로 콘텐츠 산업에서의 경쟁력을 높일 수 있는 다양한 분야의 프로젝트를 진행하고 있습니다.
                </p>
                <em className="recruit_bold_text">문화</em>
                <p className="recruit_subinfo_text">
                    스마트한 일 처리를 중요하게 생각합니다.<br />
                    각 팀원이 좋은 퍼포먼스를 내면서도 워크로드가 심하지 않도록 서로 챙겨주는 분위기이며, 개개인이 과로하지 않기 위해
                    오히려 일에 대해선 효율성과 생산성에 대한 스텐다드가 높은 편입니다.<br />
                    주니어 레벨의 사원이 한 프로젝트를 담당/리딩하기도 하는 등 업무의 자유도와 권한이 많이 주어지는 편입니다.<br />
                    신입으로 들어오면 주로 일이 주어지겠지만, 스스로 기획하고 아이템을 발굴하여 제안하는 것도 얼마든지 가능한 개방적인 분위기입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    광고, 제작, 유통, 보도 등 일반 IT 업계에서는 접하기 어려운 분야들을 대상으로 다양한 프로젝트를 경험해볼 수 있습니다.<br />
                    각 분야가 방송/미디어 업계 내에서만 경험 가능한 차별화된 커리어를 쌓을 수 있는 분야이며,<br />
                    그뿐만 아니라 직접 커뮤니케이션 하게 될 사내의 구성원 모두 국내 최고 수준의 전문가들입니다.<br /><br />
                    이러한 근무 환경 속에서 기술연구소는 개개인에게 충분한 자유도와 권한이 주어지는 유연한 문화를 갖고 있습니다.<br />
                    대규모 영상에 AI 기술 적용하여 다양한 시도를 해보고 싶은 연구원 혹은 미디어 유통 플랫폼 기반의
                    다양한 웹서비스 개발을<br />경험해보고 싶은 분에게는 최고의 부서입니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS 기술연구소에서 SW 개발 업무를 담당하고 있는 신지엽 이라고 합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">기술연구소에서 근무하게 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    저는 미디어IT팀에서 뉴스 제작 시스템 관리자로 일을 시작했습니다.<br />
                    뉴스 제작 시스템을 관리하며 뉴스 영상이 제작되고 송출되는 전반적인 워크플로우에 대해 알게 되었고,<br />
                    IT의 다양한 구성 요소들 (서버 H/W, OS, DB, WEB, 네트워크, 애플리케이션 등)에 대해 폭넓게 접할 수 있었습니다.<br /><br />
                    담당하는 시스템 관리업무를 일부 자동화하기 위하여 스크립트 기반의 프로그래밍을 접하게 되었는데,<br />
                    직접 작성한 자동화 코드들이 몸과 마음을 편하게 해주는 경험을 주면서 S/W가 주는 효용을 체감하게 되었습니다.<br /><br />
                    이런 프로그래밍의 생산성에 매력을 느끼던 중 팀 이동을 할 수 있는 기회가 생겼고, SBS에서 미디어 관련 연구개발 업무를 담당하는<br />
                    기술연구소로 오게 되었습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    얼핏 봤을 때 복잡하거나 해결이 안 될 것 같은 문제를 분석을 통해 심플한 애플리케이션으로 해결했을 때,<br />
                    업무에 만족감을 느끼고 더 재밌게 일을 하게 되는 것 같습니다. 업무상으로는 S/W 개발 업무를 맡고 있지만<br />
                    저는 스스로 개발자라기보다는  IT 지식을 기반으로 효율적 솔루션을 찾는 해결사에 가깝다고 생각합니다.<br /><br />
                    요구사항을 있는 그대로 개발하는 방식보다는 개발이 필요하게 된 배경, 이해관계자들의 니즈, 문제의 본질 등을 정확히 파악해서<br />
                    근본적인 원인을 해결해주는 S/W를 개발하는 방식의 통합적인 문제 해결의 과정을 좋아합니다.<br />
                    이렇게 했을 때, 개발 과정도 더 명확해지고 코드도 심플해졌던 것 같습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    방송/미디어 업계가 기술적으로 굉장히 빠르게 변화하고 있습니다.<br />
                    예전에는 HD 방송이나 UHD 방송과 같이 약 10년 주기로 오는 굵직한 변화의 흐름이 있었다면,<br />
                    최근에는 OTT, 클라우드, 유튜브, AI, NFT 등의 키워드 하나하나가 그냥 스치고 지나가는 법이 없습니다.<br />
                    방송 산업에 영향을 주는 인접 산업들도 격렬한 변화를 겪고 있습니다.<br /><br />
                    불과 수년 만에 디지털 광고 시장이 TV 광고 시장보다 커지게 되었고, 강력한 인프라를 바탕으로 독과점 시장을 구축한<br />
                    IPTV는 OTT라는 거대한 경쟁자를 맞이하였습니다.<br />
                    기술적인 측면과 산업적인 측면 모두 혁신이 일어나고 있고, 앞으로 변화의 속도는 더 빨라질 것으로 보입니다.<br />
                    SBS의 기술조직은 방송국 내에서 이러한 빠른 산업의 변화에 맞닿아 있는 조직으로 끊임없이 변화를 감지하고<br />
                    기회를 포착하기 위해 노력 중입니다.<br /><br />
                    경쟁자가 우리보다 나은 것이 있으면 배우고, 우리에게 없는 것이 있으면 연구해서 만들면 된다는 생각을 갖고 있습니다.<br />
                    역동적으로 변화하는 미디어 환경 속에서 같이 배우고 즐기며 도전해 나갈 동료를 구합니다.
                </p>
            </div>
        </div>);
}

export default ResearchDevelopment;